"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.CfoExpComponent = void 0;
var angular = require("angular");
var cfo_exp_chart_1 = require("./cfo-exp.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var chart_table_logic_1 = require("../../../components/chart-table/chart-table.logic");
var CfoExpComponent = /** @class */ (function (_super) {
    __extends(CfoExpComponent, _super);
    function CfoExpComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'CfoExp') || this;
        var ctrl = _this;
        $scope.$on('command:CFO_EXP', function (event, args) {
            ctrl.selectedX = 0;
            ctrl.selectedY = 0;
            ctrl.xAxisData = [];
            ctrl.yAxisData = [];
            ctrl.dataGot = args.config.data.data[0];
            ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
            ctrl.yAxisData = { data: ctrl.dataGot.headerMap[0]['data_y'], selected: ctrl.selectedY };
            ctrl.initComponent(event, args);
        });
        return _this;
    }
    CfoExpComponent.prototype.axisChanged = function () {
        var ctrl = this;
        ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
        ctrl.yAxisData = { data: ctrl.dataGot.headerMap[0]['data_y'], selected: ctrl.selectedY };
        var chartOptions = this.getChartOptions(this.graph, this.options);
        this.makeChart(chartOptions);
    };
    CfoExpComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        options['chartInverted'] = this.chartInverted;
        if (!graph || graph.length == 0) {
            this.tableData = [];
        }
        var xKey = this.dataGot.headerMap[0]['data_x'][this.selectedX]['key'];
        var xDisplay = this.dataGot.headerMap[0]['data_x'][this.selectedX]['display'];
        var yKey = this.dataGot.headerMap[0]['data_y'][this.selectedY]['key'];
        var yDisplay = this.dataGot.headerMap[0]['data_y'][this.selectedY]['display'];
        this.tableData = __assign(__assign({}, this.tableData), { inputData: __assign(__assign({}, this.tableData.inputData), { mainRows: (0, cfo_exp_chart_1.calculateCFO)((0, cfo_exp_chart_1.filterExpWithImpIg)(this.tableData.inputData.mainRows), this.xAxisData, this.yAxisData).map(function (obj) {
                    obj.name = obj.expName;
                    return obj;
                }), headerMap: [
                    { "key": xKey, "text": xDisplay },
                    { "key": yKey, "text": yDisplay },
                    { "key": "slope", "text": "Productivity" },
                    { "key": "cx", "text": "Cumulative " + xDisplay },
                    { "key": "cy", "text": "Cumulative " + yDisplay }
                ] }) });
        return (0, cfo_exp_chart_1.getChartOptions)(graph, options, this.xAxisData, this.yAxisData);
    };
    CfoExpComponent.prototype.makeChart = function (chartOptions) {
        var ctrl = this;
        var highChartGot = (0, cfo_exp_chart_1.makeChartGraph)(chartOptions.series, ctrl.xAxisData, ctrl.yAxisData, chartOptions);
        (0, basic_chart_component_1.handleResponsiveNess)(highChartGot);
    };
    CfoExpComponent.prototype.makeDrillDownTableData = function () {
        var _this = this;
        this.mainDrillDownTableData = [];
        this.selectedGraph.mainDrillDown.forEach(function (item) {
            var tmp = angular.copy(_this.tableData);
            tmp['inputData']['mainRows'] = item['data'];
            tmp['inputData']['siblingRows'] = [];
            _this.mainDrillDownTableData.push(tmp);
        });
        if (this.selectedGraph.siblingRows.length > 0) {
            var tmp = angular.copy(this.tableData);
            tmp['inputData']['mainRows'] = [];
            this.mainDrillDownTableData.push(tmp);
        }
        this.formattedDataList = [];
        this.mainDrillDownTableData.forEach(function (table) {
            _this.formattedDataList.push(chart_table_logic_1.ChartTable.generateTable(table));
        });
    };
    CfoExpComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                menu: '='
            },
            template: require("./cfo-exp.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], CfoExpComponent);
    return CfoExpComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.CfoExpComponent = CfoExpComponent;
angular.module('smartorg.r6.acts.cfoExp', []).component('cfoExp', CfoExpComponent);
module.exports = 'smartorg.r6.acts.cfoExp';
//# sourceMappingURL=cfo-exp.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/cfo-exp/cfo-exp.component.js